enum PagesUrl {
  SerpTours = 'search',
  SerpHot = 'tury',
  SerpHotels = 'hotels/search',
  SerpRailway = 'railways/search',
  GotoHotel = 'goto/hotel',
}

enum SearchSource {
  HotelOffer = 'hotelOffer',
  RailwayTour = 'railwayTour',
}

const SEARCH_SOURCE_BY_PAGE: Partial<Record<PagesUrl, SearchSource>> = {
  [PagesUrl.SerpHotels]: SearchSource.HotelOffer,
  [PagesUrl.SerpRailway]: SearchSource.RailwayTour,
};

export { PagesUrl, SearchSource, SEARCH_SOURCE_BY_PAGE };
